import { LogoMark } from '@/components/logo-mark';
import { useReducedMotion } from '@/lib/motion-presets';
import { cn } from '@/lib/utils';

type LogoLoaderProps = {
	className?: string;
	size?: number;
};

export function LogoLoader({ className, size = 112 }: LogoLoaderProps) {
	const reducedMotion = useReducedMotion();
	const animated = !reducedMotion;

	return (
		<div
			role='status'
			aria-label='Loading'
			className={cn('shrink-0', animated ? 'logo-loader-animated' : 'text-foreground', className)}
			style={{ width: size, height: size }}
		>
			<LogoMark className='h-full w-full' animated={animated} />
		</div>
	);
}
